var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

var defaultOptions = {
  once: false,
  threshold: 0,
};
var buildOptions = function (options) {
  return __assign(__assign({}, defaultOptions), options);
};
var observe = function (target, observer) {
  var targets = target instanceof Element ? [target] : target;
  for (var i = 0; i < targets.length; i++) {
      observer.observe(targets[i]);
  }
};
var createObserver = function (callback, options, condition) {
  var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
          var target = entry.target;
          if (entry.rootBounds !== null && condition(entry)) {
              callback(target, {
                  isAboveView: entry.boundingClientRect.bottom < entry.rootBounds.height / 2 && entry.boundingClientRect.top < 0,
                  isInView: entry.isIntersecting,
                  isBelowView: entry.boundingClientRect.top > entry.rootBounds.height / 2 && entry.boundingClientRect.bottom > entry.rootBounds.height,
              });
              if (options.once) {
                  observer.unobserve(target);
              }
          }
      });
  }, {
      threshold: options.threshold,
  });
  return observer;
};
function isSupported() {
  return 'IntersectionObserver' in window;
}
var isInView = function (target, callback, options) {
  if (options === void 0) { options = {}; }
  var completeOptions = buildOptions(options);
  var observer = createObserver(callback, completeOptions, function (entry) { return entry.isIntersecting; });
  observe(target, observer);
};
var isOutOfView = function (target, callback, options) {
  if (options === void 0) { options = {}; }
  var completeOptions = buildOptions(options);
  var observer = createObserver(callback, completeOptions, function (entry) { return !entry.isIntersecting; });
  observe(target, observer);
};

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command) {
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

if (!customElements.get("slider-component")) {
  class MediaSlideshow extends HTMLElement {
    constructor() {
      super();

      this.slideshowID = this.getAttribute("id");
      this.slideshow = this.querySelector(".splide.media__main");
      this.slideshowList = this.slideshow.querySelector(".splide__list");
      this.slides = this.slideshow.querySelectorAll(".splide__slide");
      this.thumbnailPlacement = this.slideshow.dataset.thumbnailPlacement;

      this.mediaThumbnailsScrolling = this.querySelector(
        ".media__thumbnails--scrolling"
      );
      if (this.mediaThumbnailsScrolling) {
        this.mediaThumbnails =
          this.mediaThumbnailsScrolling.querySelectorAll(".media__thumbnail");
      }

      this.bindEvents();

      // We init slideshow directly in Editor mode because inView is not supported under editor mode.
      if(Shopify.designMode) {
        this.initSlideshow();
      }
      
      isInView(this, (target) => {
        this.initSlideshow();
      }, {
        once: true,
        threshold: 0.02,
      });
    }

    bindEvents() {
      if (this.mediaThumbnails) {
        this.mediaThumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener("click", (event) =>
            this.selectThumbnail(event)
          );
        });
      }
    }

    initSlideshow() {
      // Main
      this.slides.forEach((slide, index) => {
        slide.setAttribute("data-slide-index", index);
      });

      this.slideshowOptions = JSON.parse(this.slideshow.dataset.options);

      this.main = new theme.Splide(this.slideshow, this.slideshowOptions);

      this.main.on("move", (index, prev, dest) => {
        if (this.mediaRatio === "adapt") {
          let indexId = index + 1;
          if (indexId < 10) {
            indexId = `0${indexId}`;
          }

          const destSlide = this.slideshow.querySelector(
            `#${this.main.root.id}-slide${indexId}`
          );
          const destSlideImage = destSlide.querySelector(
            ".product__media-image"
          );
          this.slideshowList.style.height = `${destSlideImage.offsetHeight}px`;
        }

        //   Video Pause
        // Get the current slide index
        var currentSlideIndex = index;
        // Get the current slide element
        var currentSlideElement =
          this.main.Components.Elements.slides[currentSlideIndex];

        var slick = currentSlideElement;
        this.playPauseVideo(slick, "pause");
      });

      this.main.on("moved", (newIndex, prevIndex, destIndex) => {
        if (this.mediaThumbnailsScrolling) {
          const activeClass = "media__thumbnail--active";
          const prevActive = this.querySelector(`.${activeClass}`);
          const active = this.mediaThumbnailsScrolling.querySelector(
            `.media__thumbnail[data-index="${newIndex}"]`
          );

          prevActive.classList.remove(activeClass);
          active.classList.add(activeClass);

          active.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }

        //   Video play
        // Get the current slide index
        var currentSlideIndex = newIndex;
        // Get the current slide element
        var currentSlideElement =
          this.main.Components.Elements.slides[currentSlideIndex];

        var slick = currentSlideElement;
        this.playPauseVideo(slick, "play");
      });

      this.main.on("mounted", () => {
        if (this.mediaRatio === "adapt") {
          this.onResize();

          const activeSlide = this.slideshow.querySelector(
            ".splide__slide.is-active"
          );
        }
      });

      this.main.on("ready", () => {
        // Get the current slide index
        var currentSlideIndex = 0;
        // Get the current slide element
        var currentSlideElement =
          this.main.Components.Elements.slides[currentSlideIndex];
        var slick = currentSlideElement;
        this.playPauseVideo(slick, "play");
      });

      this.main.mount();
    }

    disableDrag() {
      this.main.options = {
        drag: false,
        keyboard: false,
      };
    }

    enableDrag() {
      this.main.options = {
        drag: true,
        keyboard: true,
      };
    }

    selectThumbnail(event) {
      const activeClass = "media__thumbnail--active";
      const prevActive = this.querySelector(`.${activeClass}`);
      const active = event.currentTarget;
      const index = Number(active.dataset.index);

      prevActive.classList.remove(activeClass);
      active.classList.add(activeClass);

      this.main.go(index);
    }

    setActiveMedia(mediaId) {
      const activeSlide = this.querySelector(
        `.Product__media-item[data-media-id="${mediaId}"]`
      );
      if (!activeSlide) return;

      const activeSlideIndex = Number(activeSlide.dataset.slideIndex);
      // this.main.go(activeSlideIndex);
    }

    onResize() {
      this.slideshowResizeObserver = new ResizeObserver((entries) => {
        const activeSlideImage = this.slideshow.querySelector(
          ".splide__slide.is-active .product__media-image"
        );
        if (this.main.state.is(theme.Splide.STATES.IDLE)) {
          this.slideshowList.style.height = `${activeSlideImage.offsetHeight}px`;
        }
      });

      this.slideshowResizeObserver.observe(this.slideshow);
    }

    playPauseVideo(slide, control) {
      var currentSlide, slideType, startTime, player, video;
      currentSlide = this.activeSlide = slide;
      if (!currentSlide) return;

      let sliderElement = currentSlide.querySelector(".Product__SlideItem");
      slideType = sliderElement.dataset.videoHost;
      player = this.activeSlide.querySelector("iframe");
      startTime = 1;

      if (slideType === "vimeo") {
        switch (control) {
          case "play":
            if (
              startTime != null &&
              startTime > 0 &&
              !currentSlide.hasClass("started")
            ) {
              postMessageToPlayer(player, {
                method: "setCurrentTime",
                value: startTime,
              });
            }
            postMessageToPlayer(player, {
              method: "play",
              value: 1,
            });
            break;
          case "pause":
            postMessageToPlayer(player, {
              method: "pause",
              value: 1,
            });
            break;
        }
      } else if (slideType === "youtube") {
        switch (control) {
          case "play":
            postMessageToPlayer(player, {
              event: "command",
              func: "mute",
            });
            postMessageToPlayer(player, {
              event: "command",
              func: "playVideo",
            });
            break;
          case "pause":
            postMessageToPlayer(player, {
              event: "command",
              func: "pauseVideo",
            });
            break;
        }
      } else if (slideType === "video") {
        video = this.activeSlide.querySelector("video");
        if (video != null) {
          if (control === "play") {
            video.play();
          } else {
            video.pause();
          }
        }
      }
    }
  }
  customElements.define("slider-component", MediaSlideshow);
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      this.updateCustomAlert();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateCustomAlert();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const mediaSlideshow = document.getElementById(
      `MediaSlideshow-${this.dataset.section}`
    );
    mediaSlideshow.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    // window.history.replaceState({ }, '', this.dataset.url+'?variant='+this.currentVariant.id);
  }

  updateCustomAlert() {
    const productForms = document.querySelector(`#product-form-${this.dataset.section}`);
    const addButton = productForms.querySelector('[name="add"]');
  
    if (!this.currentVariant) {
      if(addButton) addButton.classList.toggle('select-size', true);
    } else {
      if(addButton) addButton.classList.toggle('select-size', false);
    }
  
    if (this.currentVariant) {
      const isGiftProduct = this.dataset.giftProduct === 'true';
      const optionPosition = isGiftProduct ? 1 : 2;
      const sizePicker = this.querySelector(`[data-option-position="${optionPosition}"]`);
  
      if (sizePicker) {
        sizePicker.querySelector('[data-swatch-wrapper]').classList.remove('alert-hightlight');
        sizePicker.querySelector('.text-color-error')?.remove();
      }
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      "#product-form-" + this.dataset.section
    );
    productForms.forEach((productForm) => {
      const inputs = productForm.querySelectorAll(".main-product-id");
      console.log({ inputs });
      for (var input of inputs) {
        if (input) {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      var recipient_form = productForm.querySelector("recipient-form");
      if (recipient_form) {
        recipient_form.dataset.productVariantId = this.currentVariant.id;
      }

      const currentVariant = this.currentVariant;
      const currentVariantObject = document.querySelector(
        `variant-object [data-variant-id="${this.currentVariant.id}"]`
      );
      
      document.dispatchEvent(
        new CustomEvent("variant:changed", {
          bubbles: true,
          detail: {
            variant: currentVariant,
            currentVariantObject: currentVariantObject,
          },
        })
      );
    });

    if (this.currentVariant != undefined) {
      const paymentButton = document.querySelector(".product_dynamic--buttons");
      if (paymentButton) {
        paymentButton.removeAttribute("hidden");
      }
    } else {
      document
        .querySelector(".product_dynamic--buttons")
        .setAttribute("hidden", true);
    }
  }

  renderProductInfo() {
    fetch(
      this.dataset.url +
        "?variant=" +
        this.currentVariant.id +
        "&section_id=" +
        this.dataset.section
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = "price-" + this.dataset.section;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
        document
          .getElementById("price-" + this.dataset.section)
          ?.classList.remove("visibility-hidden");

        const compareid = "compareprice-" + this.dataset.section;
        const compareDestination = document.getElementById(compareid);
        const compareSource = html.getElementById(compareid);
        if (compareSource && compareDestination)
          compareDestination.innerHTML = compareSource.innerHTML;
        document
          .getElementById("compareprice-" + this.dataset.section)
          ?.classList.remove("visibility-hidden");

        //PreOrder and Buy Button Update
        this.currentVariantObject = document.querySelector(
          `variant-object [data-variant-id="${this.currentVariant.id}"]`
        );
        if (!this.currentVariantObject) return;
        var variant_availability = this.currentVariantObject.dataset.variantAvailability;
        var button_text = this.currentVariantObject.dataset.variantStatus;
        var preorder_input_value =
          this.currentVariantObject.dataset.dispatchValue;

       if (variant_availability) var isVariantAvailabilitySet = (variant_availability?.toLowerCase?.() === 'true');

        if (isVariantAvailabilitySet == true) {
          this.toggleAddButton(
            !isVariantAvailabilitySet,
            button_text,
            preorder_input_value
          );
        } else {
          this.toggleAddButton(
            !isVariantAvailabilitySet,
            window.variantStrings.soldOut
          );
        }
      });

    const variant_label = document.querySelectorAll(
      ".ProductForm__SelectedValue"
    );
    var options = this.currentVariant.options;
    options.forEach(function (selectedValue, index) {
      if (variant_label[index]) variant_label[index].innerHTML = selectedValue;
    });
  }

  toggleAddButton(disable = true, text, preValue, modifyClass = true) {
    const productForms = document.querySelector(
      "#product-form-" + this.dataset.section
    );
    const addButton = productForms.querySelector('[name="add"]');
    const NotifyButton = productForms.querySelector(".NotifyButton");

    //We only add Property for PreOrder/Made to Order Variant to ship product status with order for fulfillment purpose.
    if (text.includes("pre-order")) {
      // We remove default preorder input to remove conflicts
      var preOrderDefaultInput = document.querySelector("#preorder-input");
      if (preOrderDefaultInput) preOrderDefaultInput.remove();

      // We again construct preorder input for preorder/made to order variant
      const preOrderInput = document.createElement("input");
      preOrderInput.type = "hidden";
      preOrderInput.setAttribute("name", "properties[Pre-Order]");
      preOrderInput.setAttribute("id", "preorder-input");
      preOrderInput.value = preValue;
      productForms.appendChild(preOrderInput);
    } else {
      // We remove preorder input and hidden property for available variant
      const preOrderInput = document.getElementById("preorder-input");
      if (preOrderInput) preOrderInput.remove();
    }

    if (!addButton) return;
    //console.log({disable});
    
    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
      addButton.removeAttribute("onclick");
      //if (NotifyButton) NotifyButton.style.display = "block";
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = text;
      addButton.removeAttribute("onclick");
      //if (NotifyButton) NotifyButton.style.display = "none";
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productForms = document.querySelector(
      "#product-form-" + this.dataset.section
    );
    const addButton = productForms.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document
      .getElementById("price-" + this.dataset.section)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// Additional Function on Variant Unavailable
function alertSelectVariant(element) {
  const button = element;
  const productForm = button.closest('product-form');
  if (!productForm) return;

  const picker = productForm.querySelector('variant-radios, variant-selects');
  if (!picker) return;

  const isGiftProduct = picker.dataset.giftProduct === 'true';
  const optionPosition = isGiftProduct ? 1 : 2;
  const sizePicker = picker.querySelector(`[data-option-position="${optionPosition}"]`);
  if (!sizePicker) return;

  const optionName = isGiftProduct
    ? removeWordAndSpace(sizePicker.dataset.optionName, 'select')
    : sizePicker.dataset.optionName;

  if(sizePicker.querySelector('[data-swatch-wrapper]').classList.contains('alert-hightlight')) {
    return false;
  }

  var alertElement = sizePicker.querySelector('.Alert');
  if(alertElement) alertElement.remove();
  
  sizePicker.querySelector('[data-swatch-wrapper]').classList.add('alert-hightlight');
  sizePicker.insertAdjacentHTML('beforeend', `<span role="alert" class="Alert text-color-error">Please select a ${optionName}.</span>`);
  scrollToElement(picker);
}

function scrollToElement(targetElement) {
  targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function removeWordAndSpace(str, wordToRemove) {
  return str.replace(new RegExp(`${wordToRemove}\\s*`, 'g'), '');
}

(function () {
  /**
    * ----------------------------------------------------------------------------
    * Notify Me Additional JS - To Support Klaviyo Custom Button
    * ----------------------------------------------------------------------------
    */
  (function () {
    document.addEventListener('variant:changed', function(event) {
      //console.log(event.detail);
      var variant = event.detail.variant;
      var currentVariantObject = event.detail.currentVariantObject;
      let productButton = document.querySelector('.product-form__buttons');
      let notifyHolding = document.querySelector('.NotifyButton--holding');

      if(window.theme.productTemplate.includes('coming-soon')) {
        document.querySelector('.NotifyButton').style.display = "block";
      } else {

        if(!currentVariantObject) return;
        var variant_availability = currentVariantObject.dataset.variantAvailability;
        var preorder_input_value = currentVariantObject.dataset.dispatchValue;
        var button_text = currentVariantObject.dataset.variantStatus;

        if (variant_availability) var isVariantAvailabilitySet = (variant_availability?.toLowerCase?.() === 'true');

        if(isVariantAvailabilitySet == true && button_text !== 'Sold out') {
          document.querySelector('.NotifyButton').style.display = "none";
          if(notifyHolding) document.querySelector('.NotifyButton--holding').style.display = "none";
          if(productButton) document.querySelector('.product-form__buttons').style.display = "";
        } else if(isVariantAvailabilitySet == false && button_text == 'Sold out') {
          document.querySelector('.NotifyButton').style.display = "none";
          if(productButton) document.querySelector('.product-form__buttons').style.display = "none";
          if(notifyHolding) document.querySelector('.NotifyButton--holding').style.display = "block";         
        } else {
          // document.querySelector('.NotifyButton').style.display = "block";
          // if(productButton) document.querySelector('.product-form__buttons').style.display = "none";
          // if(notifyHolding) document.querySelector('.NotifyButton--holding').style.display = "none";

          document.querySelector('.NotifyButton').style.display = "none";
          if(productButton) document.querySelector('.product-form__buttons').style.display = "none";
          if(notifyHolding) document.querySelector('.NotifyButton--holding').style.display = "block";  
        }
        
        // if(variant.available){
        //   document.querySelector('.NotifyButton').style.display = "none";
        //   if(productButton) document.querySelector('.product-form__buttons').style.display = "";
        // } else{
        //   document.querySelector('.NotifyButton').style.display = "block";
        //   if(productButton) document.querySelector('.product-form__buttons').style.display = "none";
        // }
      }
    });
  })();

})();